module.exports = __webpack_public_path__ + "step5_child_to_parent_daughter.7eb2f4be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_child_to_parent_daughter.jpg
// module id = AvJV
// module chunks = 0